import axios from "axios";

const PLATFORM_DOMAIN = "twothreadaccord.com";
const MAIN_SITES = [PLATFORM_DOMAIN, `www.${PLATFORM_DOMAIN}`];
const h = window.location.hostname;
const platformHost = h === new URL(process.env.REACT_APP_BACKEND_URL).hostname || h === "localhost" || h === "127.0.0.1" || /\.(emergentagent\.com|emergent\.host|preview\.emergentagent\.com)$/.test(h) || MAIN_SITES.includes(h);
export const CUSTOM_HOST = platformHost ? null : h;
export const BACKEND = CUSTOM_HOST || MAIN_SITES.includes(h) ? window.location.origin : process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (d.message) return [d.message, ...(d.errors || []).map((x) => (typeof x === "string" ? x : x.error)), ...(d.missing || [])].join(" • ");
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return JSON.stringify(d);
};

export const img = (u) => (u && u.startsWith("/api/") ? BACKEND + u : u);

export const dt = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
export const d = (s) => (s ? new Date(s).toLocaleDateString("en-IN", { dateStyle: "medium" }) : "—");

export const download = async (path, filename) => {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const upload = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/uploads", fd);
  return r.data.url;
};

export const BASE_DOMAIN = PLATFORM_DOMAIN;

export const postForm = (action, fields) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  Object.entries(fields).forEach(([k, v]) => { const i = document.createElement("input"); i.type = "hidden"; i.name = k; i.value = String(v ?? ""); form.appendChild(i); });
  document.body.appendChild(form);
  form.submit();
};
